export const PROXY_HOST = 'http://localhost';
export const PROXY_PORT = 3001;

// Contact information
export const COPYRIGHT_INFO = 'Copyright © 2024 Sidekick AI';
export const CONTACT_EMAIL = 'agustawilly@gmail.com';
export const CONTACT_NAME = 'Yohanes Willy Agusta';
export const CONTACT_BIO =
  "Hi, I'm Yohanes Willy Agusta. I do amazing web development. I have tons of experience with projects ranging from simple web apps to full-featured e-commerce platforms. I'd love to work with you! ";

export const CONTACT_PHONE = '+62 812 8296 1168';

// Social media
export const FACEBOOK_URL = 'https://web.facebook.com/yohaneswilly.agusta/';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/willyagusta/';

